// 获取是否是私有化环境
export const IS_PRIVATE = import.meta.env.BASE_URL === '/edge-web/';

export const TOKEN_KEY = IS_PRIVATE ? 'privateMeetingSummaryToken' : 'meetingSummaryToken';

// 获取应用的 basename
export const APP_BASENAME = IS_PRIVATE ? '/edge-web' : '';

// 获取不包含 basename 的路径名
export const getPathnameWithoutBasename = () => {
  const { pathname } = window.location;
  if (IS_PRIVATE && pathname.startsWith('/edge-web')) {
    return pathname.substring('/edge-web'.length) || '/';
  }
  return pathname;
};

/**
 * 判断是否需要加密传输
 * 优先级：
 * 1. 如果 localStorage 中有 ENCRYPT_TRANSMISSION_ENABLED（值为 'true' 或 'false'），使用该值
 * 2. 否则根据 IS_PRIVATE 判断：IS_PRIVATE 为 true（私有化环境）时不加密，为 false（公有云环境）时加密
 * @returns 是否需要加密传输
 */
export const shouldEncryptTransmission = (): boolean => {
  const stored = localStorage.getItem('ENCRYPT_TRANSMISSION_ENABLED');
  if (stored !== null) {
    return stored === 'true';
  }
  // IS_PRIVATE 为 true（私有化环境）时不加密，为 false（公有云环境）时加密
  // return !IS_PRIVATE;
  return false;
};